import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  max-width: 100%;
  margin-top: 12px;
  overflow: hidden;
`;

export const SubContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 12px;
`;

export const BoxContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const StatusBadge = styled.div`
  width: 18px;
  height: 18px;
  border-radius: 50%;
  margin-right: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 700;
  color: #fff;
  background: ${({ $variant }) =>
    $variant === 'origin'
      ? '#28a745'
      : $variant === 'final'
      ? '#007bff'
      : '#007bff'};
`;
